module.exports = __webpack_public_path__ + "static/img/icon-earth.217b1f1f.png";